<template>
  <div class="emoji">
    <img :src="path" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({code: String});
const TWEMOJI_PATH = '/twemoji';
const TWEMOJI_TYPE = 'svg';
const file = computed(() => [props.code, TWEMOJI_TYPE].join('.'));
const path = computed(() => [TWEMOJI_PATH, file.value].join('/'));
</script>

<style scoped>
.emoji
{
  @apply flex justify-center items-center;
}

img
{
  @apply inline-block;
  @apply w-full h-full;
}
</style>
